/*
 * Initializes Swiper sliders for Related Articles sections.
 * Targets containers with [data-related-articles] added by sections/article-related-slider.liquid
 */
(function () {
	function initRelatedArticlesSliders() {
		if (typeof Swiper === 'undefined') return;

		var containers = document.querySelectorAll('[data-related-articles]');
		if (!containers.length) return;

		containers.forEach(function (container) {
			// Prefer controls inside the external navigation wrapper
			var wrapper = container.closest('.article-related-slider__wrapper') || container.parentElement;
			var navRoot = wrapper ? wrapper.querySelector('.article-related-slider__navigation') : null;
			var prevEl = navRoot ? navRoot.querySelector('.swiper-button-prev') : container.querySelector('.swiper-button-prev');
			var nextEl = navRoot ? navRoot.querySelector('.swiper-button-next') : container.querySelector('.swiper-button-next');
			var paginationEl = navRoot ? navRoot.querySelector('.swiper-pagination') : container.querySelector('.swiper-pagination');

			// eslint-disable-next-line no-new
			new Swiper(container, {
				slidesPerView: 1.15,
				spaceBetween: 8,
				watchOverflow: true,
				loop: true,
				keyboard: {
					enabled: true
				},
				a11y: {
					enabled: true
				},
				pagination: paginationEl ? {
					el: paginationEl,
					clickable: true
				} : undefined,
				navigation: prevEl && nextEl ? {
					prevEl: prevEl,
					nextEl: nextEl
				} : undefined,
				breakpoints: {
					768: {
						slidesPerView: 1.75
					},
					1025: {
						slidesPerView: 2.45
					}
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initRelatedArticlesSliders);
	} else {
		initRelatedArticlesSliders();
	}
})();
